/**
 * 丹方数据
 */

export interface RecipeIngredient {
  itemId: string;
  itemName: string;
  count: number;
}

export interface Recipe {
  id: string;
  name: string;
  desc: string;
  /** 产出物品ID */
  resultItemId: string;
  resultCount: number;
  /** 必需材料（完整丹方全部显示，不完整丹方只显示已知部分） */
  ingredients: RecipeIngredient[];
  /** 最低炼丹熟练度 */
  minSkill: number;
  /** 是否完整丹方（完整=玩家知道全部材料） */
  isComplete: boolean;
  /** 未完整时，隐藏的材料索引（从0开始） */
  hiddenIngredientIndexes?: number[];
}

export const RECIPES: Recipe[] = [
  {
    id: 'recipe_hp_pill',
    name: '回春丹方',
    desc: '基础疗伤丹药，修仙界最普及的丹方之一。',
    resultItemId: 'hp_pill',
    resultCount: 1,
    ingredients: [
      { itemId: 'spirit_herb', itemName: '灵草', count: 2 },
    ],
    minSkill: 0,
    isComplete: true,
  },
  {
    id: 'recipe_mp_pill',
    name: '聚灵丹方',
    desc: '恢复灵力的基础丹药，炼制简单。',
    resultItemId: 'mp_pill',
    resultCount: 1,
    ingredients: [
      { itemId: 'spirit_herb', itemName: '灵草', count: 1 },
      { itemId: 'monster_core', itemName: '妖丹', count: 1 },
    ],
    minSkill: 2,
    isComplete: false,
    hiddenIngredientIndexes: [1], // 不完整丹方：不知道需要妖丹
  },
  {
    id: 'recipe_exp_pill',
    name: '悟道丹方',
    desc: '提升修炼感悟的丹药，材料较为珍贵。',
    resultItemId: 'exp_pill',
    resultCount: 1,
    ingredients: [
      { itemId: 'spirit_herb', itemName: '灵草', count: 2 },
      { itemId: 'monster_core', itemName: '妖丹', count: 3 },
    ],
    minSkill: 5,
    isComplete: false,
    hiddenIngredientIndexes: [1], // 只知道需要灵草，不知道需要妖丹
  },
  {
    id: 'recipe_hp_pill_x3',
    name: '回春丹方（精）',
    desc: '批量炼制回春丹的进阶丹方，一次出三颗。',
    resultItemId: 'hp_pill',
    resultCount: 3,
    ingredients: [
      { itemId: 'spirit_herb', itemName: '灵草', count: 5 },
      { itemId: 'monster_core', itemName: '妖丹', count: 1 },
    ],
    minSkill: 8,
    isComplete: true,
  },
  {
    id: 'recipe_breakthrough_pill',
    name: '筑基丹方',
    desc: '突破大境界的必备丹药，材料昂贵但物有所值。',
    resultItemId: 'breakthrough_pill',
    resultCount: 1,
    ingredients: [
      { itemId: 'monster_core', itemName: '妖丹', count: 5 },
      { itemId: 'spirit_herb', itemName: '灵草', count: 8 },
    ],
    minSkill: 10,
    isComplete: false,
    hiddenIngredientIndexes: [0], // 需要发现妖丹材料
  },
];

/** 基础成功率 */
export const BASE_ALCHEMY_RATE = 0.3;
/** 每点熟练度加成 */
export const SKILL_BONUS_PER_LEVEL = 0.02;
/** 完整丹方加成 */
export const COMPLETE_RECIPE_BONUS = 0.20;
/** 不完整丹方惩罚 */
export const INCOMPLETE_RECIPE_PENALTY = -0.20;
